import { render, staticRenderFns } from "./indicator.component.vue?vue&type=template&id=b7cd0952&scoped=true&"
import script from "./indicator.component.vue?vue&type=script&lang=ts&"
export * from "./indicator.component.vue?vue&type=script&lang=ts&"
import style0 from "./indicator.component.vue?vue&type=style&index=0&id=b7cd0952&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cd0952",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
